"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.web = web;

require("core-js/modules/es6.promise");

function web() {
  return new Promise(function (resolve) {
    return resolve();
  });
}